<template>
  <SlideInTransitionTop>
    <mp-link
      v-if="animated || !animateIn"
      :to="$u(link)"
      class="
        flex
        items-center
        justify-center
        px-6
        py-2
        text-sm
        leading-none
        tracking-wider
        uppercase
        transition-all
        border border-solid
        cursor-pointer
        min-w-fit
        rounded-3xl
        lg:px-8 lg:py-3
        hover:border-black
      "
      :class="{
        'border-black': isActive,
        'border-gray': !isActive,
        'scale-105': clickAnimationActive,
      }"
    >
      <slot />
    </mp-link>
  </SlideInTransitionTop>
</template>
<script>
import SlideInTransitionTop from '@/components/transitions/SlideInTransitionTop.vue'
export default {
  name: 'CategorySelector',
  components: {
    SlideInTransitionTop,
  },
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    position: {
      type: Number,
      required: true,
    },
    link: {
      type: Object,
      required: true,
    },
    animateIn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      animated: false,
      clickAnimationActive: false,
    }
  },
  computed: {
    selectorId: ({ link, $u }) => $u(link)?.split('/').pop(),
    activeLink: ({ $route }) => $route?.params?.pathMatch?.split('/').pop(),
    isActive: ({ activeLink, selectorId }) => activeLink === selectorId,
  },
  watch: {
    clickAnimationActive(val) {
      if (val) {
        setTimeout(() => {
          this.clickAnimationActive = false
        }, 200)
      }
    },
  },
  mounted() {
    if (this.animateIn) {
      setTimeout(() => {
        this.animated = true
      }, this.position * 100)
    }
  },
}
</script>
